export default "__VITE_ASSET__7iMcRsFA__"